import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-search-account-head-master',
  templateUrl: './search-account-head-master.component.html',
  styleUrls: ['./search-account-head-master.component.scss']
})
export class SearchAccountHeadMasterComponent implements OnInit {
  searchAccountmaster:any;
  searchAheadlimaster:any;
  arraylist:any=[];
  orignaldata:any=[];
  constructor(public dialog: MatDialog,public dialogRef: MatDialogRef<SearchAccountHeadMasterComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { 
    this.orignaldata = data
    this.arraylist =data;
  }

  ngOnInit(): void {
  }
  closedialog() {
    this.dialogRef.close(0);
  }


   onSearch(searchTerm: string) {
  const lowerSearchTerm = searchTerm.toLowerCase();
  if (!lowerSearchTerm) {
    this.arraylist = this.orignaldata;
    return;
  }
  const exactMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (item.accountHeadName && item.accountHeadName.toLowerCase() === lowerSearchTerm)
    );

  const partialMatches = this.arraylist
    .map((item, index) => ({ ...item, _originalIndex: index }))
    .filter(item =>
      (
        (item.accountHeadName && item.accountHeadName.toLowerCase().includes(lowerSearchTerm))
      ) &&
      !exactMatches.find(m => m._originalIndex === item._originalIndex)
    );

  // const filteredData = [...exactMatches, ...partialMatches];

  this.arraylist = [...exactMatches, ...partialMatches];// assign filtered data back
}

  selectRowdata(rowdata){
    this.dialogRef.close(rowdata);
  }



}
